import api from './axios.js';

export const usersApi = {
  list: () => api.get('/users'),
  team: () => api.get('/users/team'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  deactivate: (id) => api.delete(`/users/${id}`),
  changePassword: (data) => api.put('/users/me/change-password', data),
  resetPassword: (id, newPassword) => api.put(`/users/${id}/reset-password`, { newPassword }),
};
